<template>
  <div>
    <el-row>
      <el-col>
        <el-form ref="searchForm" :model="searchForm" :inline="true" style="margin-top:20px">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.Name"></el-input>
          </el-form-item>
          <el-form-item label="品牌：">
            <el-input size="medium" v-model="searchForm.brand"></el-input>
          </el-form-item>
          <el-form-item label="规格：">
            <el-input size="medium" v-model="searchForm.specification"></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input size="medium" v-model="searchForm.code"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="handleSearch()">筛选</el-button>
            <el-button size="medium" @click="openAdd()" v-show="fun_dic[108050101]">新增</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData">
          <el-table-column label="序号" type="index" width="60"></el-table-column>
          <el-table-column label="产品编码" prop="INNER_CODE"></el-table-column>
          <el-table-column label="产品名称" prop="NAME"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <el-tag type="text" v-show="scope.row.USING_ID > 0">在用SKU</el-tag>
              <el-tag type="text" v-show="scope.row.USING_ID == 0">非在用SKU</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" v-show="scope.row.USING_ID == 0" @click="openAddDialog(scope.row)">添加使用</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleChange" :current-page.sync="currentPage" :page-size="pageSize" layout="total,prev, pager, next, jumper"
          :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <el-dialog title="新增SKU" center :visible.sync="addFormVisible" width="450px">
      <el-form :model="addForm" ref="addForm" :label-width="formLabelWidth">
        <el-form-item label="产品名称：">
          <el-input v-model="addForm.NAME"></el-input>
        </el-form-item>
        <el-form-item label="单位：">
          <el-select v-model="addForm.TYPE_UNIT" style="width: 300px" placeholder="请选择" clearable>
            <el-option v-for="item in TYPE_UNIT_LIST" :key="item.KD_CODE + '/' + item.UNIT_ID" :label="item.TYPE_UNIT"
              :value="item.KD_CODE + '/' + item.UNIT_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌：">
          <el-input v-model="addForm.BRAND"></el-input>
        </el-form-item>
        <el-form-item label="规格：">
          <el-input v-model="addForm.SPECIFICATION"></el-input>
        </el-form-item>
        <el-form-item label="一级大类：">
          <el-select filterable v-model="addForm.FIRST_TYPE" style="width: 100%" @change="getSecond()">
            <el-option v-for="item in firstLists" :key="item.INNER_CODE" :value="item.INNER_CODE" :label="item.NAME">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级大类：">
          <el-select filterable v-model="addForm.SECOND_TYPE" style="width: 100%">
            <el-option v-for="item in secondLists" :key="item.INNER_CODE" :value="item.INNER_CODE" :label="item.NAME">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出库方式：">
          <el-select filterable v-model="addForm.OW_TYPE" style="width: 100%">
            <el-option v-for="item in OWLists" :key="item.ID" :value="item.ID" :label="item.NAME"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="新增在用SKU" center :visible.sync="matchSKUFormVisible" width="700px" :close-on-click-modal="false">
      <el-row>
        <el-form :model="matchSKUForm" ref="matchSKUForm" size="small" class="el-form--label-justify" :label-width="formLabelWidth">
          <el-col :span="12">
            <el-form-item label="产品分类：">
              <el-select v-model="matchSKUForm.CATALOG_ID" style="width:80%">
                <el-option v-for="item in catalogList" :key="item.ID" :label="item.CATALOG_NAME" :value="item.ID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="体积：">
              <el-input v-model="matchSKUForm.VOLUME" style="width:80%"></el-input>
            </el-form-item>
            <el-form-item label="温区：">
              <label slot="label">温&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;区：</label>
              <el-select v-model="matchSKUForm.WZ_TYPE_ID" style="width:80%">
                <el-option v-for="item in WZ_list" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出库方式：">
              <el-select v-model="matchSKUForm.OW_TYPE" style="width:80%">
                <el-option v-for="item in wayOut" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="安全库存：">
              <el-input v-model="matchSKUForm.SAFETY_STOCK" style="width:80%"></el-input>
            </el-form-item>
            <el-form-item label="销项税率：">
              <el-input v-model="matchSKUForm.OUTPUT_VAT" style="width:70%"></el-input> <span>%</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="重量：">
              <el-input v-model="matchSKUForm.WEIGHT" style="width:80%"></el-input>
            </el-form-item>
            <el-form-item label="预警期：">
              <label slot="label">预&nbsp;&nbsp;警&nbsp;&nbsp;期：</label>
              <el-input v-model="matchSKUForm.WARNING_PERIOD" style="width:50%"></el-input>
              <el-select v-model="matchSKUForm.WP_TIME_TYPE" style="width:30%">
                <el-option v-for="item in date_list" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="保质期：">
              <label slot="label">保&nbsp;&nbsp;质&nbsp;&nbsp;期：</label>
              <el-input v-model="matchSKUForm.QGP" style="width:50%"></el-input>
              <el-select v-model="matchSKUForm.QGP_TIME_TYPE" style="width:30%">
                <el-option v-for="item in date_list" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="下架期：">
              <label slot="label">下&nbsp;&nbsp;架&nbsp;&nbsp;期：</label>
              <el-input v-model="matchSKUForm.PULL_OFF_PERIOD" style="width:50%"></el-input>
              <el-select v-model="matchSKUForm.PO_TIME_TYPE" style="width:30%">
                <el-option v-for="item in date_list" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="进项税率：">
              <el-input v-model="matchSKUForm.INPUT_VAT" style="width:70%"></el-input> <span>%</span>
            </el-form-item>
            <el-form-item label="库位编码：">
              <el-select v-model="matchSKUForm.LOCATION_CODE" style="width:80%">
                <el-option v-for="item in positionLi" :key="item.ID" :label="item.CODE" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div slot="footer" center class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" @click="addProduct('matchSKUForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getActionFun } from 'api/login';
import {
  addUseSKU, getClassFun, queryWQ,
} from '@/assets/api/skuManage';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      searchForm: {},
      formLabelWidth: '100px',
      OWLists: [
        {
          ID: '1',
          NAME: 'MTO',
        },
        {
          ID: '2',
          NAME: 'MTS',
        },
        {
          ID: '3',
          NAME: 'DS',
        },
      ],
      TYPE_UNIT_LIST: [],
      ADD_TYPE_UNIT: '',
      addFormVisible: false,
      addForm: {},
      pageSize: 10,
      currentPage: 1,
      totalCount: 0,
      firstLists: [],
      secondLists: [],
      PAGE_ID: '1080501', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 108050101: 0 },
      matchSKUForm: {
        WZ_TYPE_ID: 0,
        OUTPUT_VAT: 0,
        OW_TYPE: 0,
        WARNING_PERIOD: 0,
        INPUT_VAT: 0,
        QGP: 0,
        PULL_OFF_PERIOD: 0,
        QGP_TIME_TYPE: 1,
        PO_TIME_TYPE: 1,
        WP_TIME_TYPE: 1,
        LOCATION_CODE: 0,
        SAFETY_STOCK: 0,
        VOLUME: 0,
        WEIGHT: 0,
      },
      matchSKUFormVisible: false,
      date_list: [
        {
          ID: 1,
          NAME: '年',
        }, {
          ID: 2,
          NAME: '季',
        }, {
          ID: 3,
          NAME: '月',
        }, {
          ID: 4,
          NAME: '日',
        }, {
          ID: 5,
          NAME: '时',
        },
      ], // 时间类型
      WZ_list: [], // 温区
      wayOut: [
        {
          ID: 1,
          NAME: 'MTO',
        }, {
          ID: 2,
          NAME: 'MTS',
        }, {
          ID: 3,
          NAME: 'DS',
        },
      ],
      positionLi: [],
      catalogList: [],
    };
  },
  methods: {
    queryUnit() {
      const params = {
        SERVICE_ID: '60001',
        OTYPE: 1,
        PAGE_INDEX: 0,
        PAGE_SIZE: 100000,
      };
      http.post(params).then((result) => {
        if (result[0]) {
          this.TYPE_UNIT_LIST = result[0].UNIT_DATA;
          this.totalNum = result[0].TOTAL_COUNT;
        } else {
          this.TYPE_UNIT_LIST = [];
          this.totalNum = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleSearch() {
      const params = {
        SERVICE_ID: '10050',
        OTYPE: 1,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
      };
      if (this.searchForm.brand) {
        params.BRAND = this.searchForm.brand;
      } else {
        params.BRAND = '';
      }
      if (this.searchForm.specification) {
        params.SPECIFICATION = this.searchForm.specification;
      } else {
        params.SPECIFICATION = '';
      }
      if (this.searchForm.Name && this.searchForm.Name != '') {
        params.SHORT_NAME = this.searchForm.Name;
      }
      if (this.searchForm.code && this.searchForm.code != '') {
        params.PRODUCT_CODE = this.searchForm.code;
      }
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result[0].list;
          this.totalCount = result[0].TOTAL;
        } else {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openAddDialog(row) {
      this.matchSKUForm = row;
      this.matchSKUFormVisible = true;
    },
    addProduct() {
      const params = {
        ALIAS_NAME: this.matchSKUForm.NAME,
        PRODUCT_CODE: this.matchSKUForm.INNER_CODE,
        CATALOG_ID: sessionStorage.getItem('kindId'),
        SAFETY_STOCK: this.matchSKUForm.SAFETY_STOCK ? this.matchSKUForm.SAFETY_STOCK : 0,
        WZ_TYPE_ID: this.matchSKUForm.WZ_TYPE_ID ? this.matchSKUForm.WZ_TYPE_ID : 0,
        OW_TYPE: this.matchSKUForm.OW_TYPE ? this.matchSKUForm.OW_TYPE : 0,
        QGP: Number(this.matchSKUForm.QGP) ? Number(this.matchSKUForm.QGP) : 0,
        QGP_TIME_TYPE: this.matchSKUForm.QGP_TIME_TYPE ? this.matchSKUForm.QGP_TIME_TYPE : 1,
        WARNING_PERIOD: Number(this.matchSKUForm.WARNING_PERIOD) ? Number(this.matchSKUForm.WARNING_PERIOD) : 0,
        WP_TIME_TYPE: this.matchSKUForm.WP_TIME_TYPE ? this.matchSKUForm.WP_TIME_TYPE : 1,
        PULL_OFF_PERIOD: Number(this.matchSKUForm.PULL_OFF_PERIOD) ? Number(this.matchSKUForm.PULL_OFF_PERIOD) : 0,
        PO_TIME_TYPE: this.matchSKUForm.PO_TIME_TYPE ? this.matchSKUForm.PO_TIME_TYPE : 1,
        INPUT_VAT: Number(this.matchSKUForm.INPUT_VAT) ? Number(this.matchSKUForm.INPUT_VAT) : 0,
        OUTPUT_VAT: Number(this.matchSKUForm.OUTPUT_VAT) ? Number(this.matchSKUForm.OUTPUT_VAT) : 0,
        DEFAULT_LOCATION_ID: Number(this.matchSKUForm.LOCATION_CODE) ? Number(this.matchSKUForm.LOCATION_CODE) : 0,
        VOLUME: Number(this.matchSKUForm.VOLUME) ? Number(this.matchSKUForm.VOLUME) : 0,
        WEIGHT: Number(this.matchSKUForm.WEIGHT) ? Number(this.matchSKUForm.WEIGHT) : 0,
      };
      addUseSKU(params).then((result) => {
        this.$message.show({ text: '新增成功', type: 'success' });
        this.matchSKUFormVisible = false;
        document.body.style.cursor = 'default';
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        document.body.style.cursor = 'default';
      });
    },
    openAdd() {
      this.addFormVisible = true;
    },
    submitAdd() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const strlist = this.addForm.TYPE_UNIT.split('/');
          this.TYPE_UNIT_LIST.map((item) => {
            if (item.UNIT_ID == strlist[1]) {
              this.ADD_TYPE_UNIT = item.TYPE_UNIT;
            }
          });
          const params = {
            SERVICE_ID: '10050',
            OTYPE: 11,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            SHORT_NAME: this.addForm.NAME,
            SUPPLIER_ID: sessionStorage.getItem('tcId'),
            CATALOG_ID: sessionStorage.getItem('kindId'),
            OW_TYPE: this.addForm.OW_TYPE,
            TYPE_UNIT: this.ADD_TYPE_UNIT,
            UNIT_ID: strlist[1],
            KD_CODE: strlist[0],
            SECOND_CATALOG_CODE: this.addForm.SECOND_TYPE,
          };
          if (this.addForm.SPECIFICATION) {
            params.SPECIFICATION = this.addForm.SPECIFICATION;
          } else {
            params.SPECIFICATION = '';
          }
          if (this.addForm.BRAND) {
            params.BRAND = this.addForm.BRAND;
          } else {
            params.BRAND = '';
          }
          if (!this.addForm.NAME || !this.ADD_TYPE_UNIT || !this.addForm.FIRST_TYPE || !this.addForm.SECOND_TYPE || !this.addForm.OW_TYPE) {
            this.$message.show({ text: '请输入产品名称、单位、一级大类、二级大类和出库方式', type: 'warning' });
            return false;
          }
          http.post(params).then((result) => {
            this.$message.show({ text: '新增成功', type: 'success' });
            this.$refs.addForm.resetFields();
            this.addFormVisible = false;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    close() {
      this.addFormVisible = false;
      this.matchSKUFormVisible = false;
    },
    queryFirstCatalog() {
      const param = {
        SERVICE_ID: '10200',
        OTYPE: 3,
        PAGEINDEX: 0,
        PAGESIZE: 1000,
      };
      http.post(param).then((result) => {
        this.firstLists = result.length > 0 ? result[0].OP_ROLE : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    querySecondCatalog() {
      const param = {
        SERVICE_ID: '10201',
        OTYPE: 3,
        PAGEINDEX: 0,
        PAGESIZE: 1000,
        FIRST_CATALOG_CODE: this.addForm.FIRST_TYPE,
      };
      http.post(param).then((result) => {
        this.secondLists = result.length > 0 ? result[0].OP_ROLE : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    getSecond() {
      this.querySecondCatalog();
    },
    // 拉取温区
    queryWZ() {
      queryWQ()
        .then((result) => {
          this.WZ_list = result;
        }).catch((error) => {
        });
    },
    queryCatalog() {
      const params = {};
      getClassFun(params).then((result) => {
        if (result.length !== 0) {
          this.catalogList = result;
        } else {
          this.catalogList = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    handleChange(e) {
      this.currentPage = e;
      this.handleSearch();
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryCatalog();
    this.queryWZ();
    this.queryFirstCatalog();
    this.queryBeforeFun();
    this.queryUnit();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/systemSetting/addProduct.vue